import { reduce } from 'es-toolkit/compat';
import { Features, core } from '@tock/coretypes';

export function createFeaturesObject(payload: { feature: core.Feature.FeatureName[] }) {
  return reduce(
    payload.feature,
    function (features: Features, feature: core.Feature.FeatureName) {
      features[feature] = true;
      return features;
    },
    {}
  );
}
